import { createSlice } from '@reduxjs/toolkit';

export const loadingSlice = createSlice({
  name: 'loading',
  initialState: {
    visible: false,
  },
  reducers: {
    showLoading: state => {
      state.visible = true
    },
    hideLoading: state => {
      state.visible = false
    },
  }
})

export const { showLoading, hideLoading } = loadingSlice.actions;
export default loadingSlice.reducer;
